import { MessageFooter } from '@zg-rentals/satellite-components';

type Props = {
  isMessageOwner: boolean;
  messageContent: string;
  messageDateMs: string;
};

const PhoneLead = ({ isMessageOwner, messageContent, messageDateMs }: Props): JSX.Element => {
  return (
    <>
      <audio controls={true}>
        <source src={messageContent} />
      </audio>

      <MessageFooter isMessageOwner={isMessageOwner} messageDateMs={messageDateMs} />
    </>
  );
};

export default PhoneLead;
